import AnnounceKit from 'announcekit-react';

const WIDGET_URL = process.env.REACT_APP_ANNOUNCEMENTS_EMBED_WIDGET;

const Announcements = () => {
    return (
        <div className="card-wrapper" style={{ height: '80vh' }}>
            <AnnounceKit widget={WIDGET_URL} embedWidget={true} />
        </div>
    );
};

export default Announcements;
